'use strict';

import { easeOutExpo } from "../../../_js/common/_util";

export default class Footer {
    constructor() {
        const $footerFab = $('.back-to-top');
        $footerFab.on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({ scrollTop: 0 }, {
                duration: 1500,
                easing: 'easeInOutExpo'
            });
        });

        $(window).on('resize scroll', function (e) {
            let st = $(this).scrollTop();

            if (st >= 800) {
                $footerFab.stop().clearQueue().fadeIn(easeOutExpo);
            } else {
                $footerFab.stop().clearQueue().fadeOut(easeOutExpo);
            }
            // footerWatcher.enterViewport(function () {
            //     $footerFab.animate({
            //         easeOutExpo,
            //         opacity: 1
            //     });
            //     $footerFab.css("pointer-events", "auto")
            // });
            
            // footerWatcher.exitViewport(function () {
            //     $footerFab.animate({
            //         easeOutExpo,
            //         opacity: 0
            //     });
            //     $footerFab.css("pointer-events", "none")
            // });
        });
    }
}
